import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "components/footers/FiveColumnDark";
import Hero from "components/hero/Hero";
import DecoratorBlobDesign from "components/cards/DecoratorBlobDesign";
import tw from "twin.macro";
import styled from "styled-components";
import CompanyProfile from "components/features/CompanyProfile";
import Suppliers from "components/blogs/Suppliers";
import CompanyLocation from "components/features/CompanyLocation";
import CompanyHistory from "components/hero/CompanyHistory";
import HistoryOverview from "components/history/HistoryOverview";
import OrganizationChart from "components/features/OrganizationDirectory";
import OrganizationChartSmall from "components/features/OrganizationDirectorySmall";
import BoardMember from "components/cards/BoardMember";
import GlobalStyle from "helpers/GlobalStyle";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import useScreenSize from "helpers/useScreenSize";
import DirectorMessage from "components/testimonials/DirectorMessage";
import haraImg from "images/people/hara.jpg";

const BgWrapper = styled.div`
  ${tw`fancy-feature-mask`}
`;

export default () => {
  const { isXs } = useScreenSize();
  const location = useLocation();

  const aboutProfileRef = useRef();
  const aboutSupplierRef = useRef();
  const aboutComLocationRef = useRef();
  const aboutComMemberRef = useRef();
  const aboutComOrgRef = useRef();
  const aboutTimelineRef = useRef();

  const scrollToTarget = (targetRef) => {
    if (targetRef.current) {
      const offset = 100; // Add an offset of 100px to avoid content disappearing
      const targetPosition =
        targetRef.current.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const hash = location.hash;
    if (hash === "#profile") {
      scrollToTarget(aboutProfileRef);
    } else if (hash === "#location") {
      scrollToTarget(aboutComLocationRef);
    } else if (hash === "#suppliers") {
      scrollToTarget(aboutSupplierRef);
    } else if (hash === "#history") {
      scrollToTarget(aboutTimelineRef);
    } else if (hash === "#org-chart") {
      scrollToTarget(aboutComOrgRef);
    } else if (hash === "#board-member") {
      scrollToTarget(aboutComMemberRef);
    }
  }, [
    location,
    aboutProfileRef,
    aboutSupplierRef,
    aboutTimelineRef,
    aboutComLocationRef,
    aboutComOrgRef,
    aboutComMemberRef,
  ]);

  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <div id="director">
          {" "}
          <DirectorMessage imageSrc={haraImg} />
        </div>

        <div id="profile" ref={aboutProfileRef}>
          <CompanyProfile isXs={isXs} />
        </div>

        <div id="location" ref={aboutComLocationRef}>
          <div className={!isXs ? "gradient-container" : ""}>
            <CompanyLocation isXs={isXs} />
          </div>
        </div>

        <div id="board-member" ref={aboutComMemberRef}>
          <BoardMember isXs={isXs} />
        </div>

        <div id="org-chart" ref={aboutComOrgRef}>
          {isXs ? <OrganizationChartSmall /> : <OrganizationChart />}
        </div>

        <DecoratorBlobDesign />
        <div id="suppliers" ref={aboutSupplierRef}>
          <BgWrapper>
            <Suppliers isXs={isXs} />
          </BgWrapper>
        </div>
        <DecoratorBlobDesign />

        <DecoratorBlobDesign />
        <div id="history" ref={aboutTimelineRef}>
          {isXs ? (
            <HistoryOverview isXs={isXs} />
          ) : (
            <CompanyHistory isXs={isXs} />
          )}
        </div>

        <div style={{ marginTop: "60px" }}>
          <Footer isXs={isXs} />
        </div>
      </SplashAnimationContainer>
    </div>
  );
};
